import { FC, useState, Dispatch, SetStateAction } from 'react';

import View from './view';

import { MainServiceApi } from '../../../../../lib/api/mainServiceApi';

import { FlashbarProps } from '@awsui/components-react';
import {
  IRejectUserReactivationRequest,
  IUserReactivationRequest
} from '../../../../../interfaces/domain/userReactivationRequest';

interface IndexProps {
  userReactivationRequests: IUserReactivationRequest[];
  setFlashBarItems: Dispatch<SetStateAction<FlashbarProps.MessageDefinition[]>>;
  setRejectUserReactivationRequestModalIsVisible: Dispatch<SetStateAction<boolean>>;
  refreshUserReactivationRequestTable: () => void;
}
const RejectUserReactivationRequestForm: FC<IndexProps> = ({
  userReactivationRequests,
  setFlashBarItems,
  setRejectUserReactivationRequestModalIsVisible,
  refreshUserReactivationRequestTable
}) => {
  const formValues: IRejectUserReactivationRequest = {
    rejectionReason: ''
  };
  const [modelFlashBarItems, setModelFlashBarItems] = useState<
    FlashbarProps.MessageDefinition[]
  >([]);

  const handleSubmittedForm = async (data: IRejectUserReactivationRequest) => {
    setModelFlashBarItems([
      {
        type: 'success',
        loading: true,
        content: 'Processing...'
      }
    ]);
    const api = new MainServiceApi();
    for (const userReactivationRequest of userReactivationRequests) {
      api
        .rejectUserReactivationRequest(
          userReactivationRequest.uuid,
          data.rejectionReason
        )
        .then(() => {
          setRejectUserReactivationRequestModalIsVisible(false);
          setModelFlashBarItems([]);
          setFlashBarItems([
            {
              type: 'success',
              dismissible: true,
              dismissLabel: 'Dismiss message',
              onDismiss: () => setFlashBarItems([]),
              content: <>User Reactivation Request was rejected successfully!</>
            }
          ]);
          refreshUserReactivationRequestTable();
        })
        .catch(() => {
          setModelFlashBarItems([
            {
              type: 'error',
              dismissible: true,
              dismissLabel: 'Dismiss message',
              onDismiss: () => setModelFlashBarItems([]),
              content: <> Unable to reject User Reactivation Request!</>
            }
          ]);
        });
    }
  };

  return (
    <View
      formValues={formValues}
      modelFlashBarItems={modelFlashBarItems}
      handleSubmittedForm={handleSubmittedForm}
    />
  );
};

export default RejectUserReactivationRequestForm;
